import { BCDataGrid } from '@bimser/components';
import DataGrid2 from '../..';

export function onContentReady(
	this: DataGrid2,
	e: BCDataGrid.Entities.DataGridTypes.ContentReadyEvent
) {
	if (!e.component.hasEditData()) {
		this.__isNewRowEditing = false;
	}
}
